import React, { useState, useEffect } from "react";


// import JS files
import MuiModal from "../../mui/MuiModal";
import MuiButton from "../../mui/MuiButton";
import MuiTextField from "../../mui/MuiTextField";
// import Others files

const RejectModal = ({
  width,
  isOverflow,
  isNotBackdropClick,
  openModal,
  setOpenModal,
  disableEscapeKeyDown = true,
  apiCall,
  rejectDescription,
  setRejectDescription
  // disableBackdropClick = true,
}) => {
  const [description , setDescription] = useState();
  return (
    <>
        <MuiModal
          openModal={openModal}
          setOpenModal={setOpenModal}
          width={width}
          isOverflow={isOverflow}
          isNotBackdropClick={isNotBackdropClick}
          disableEscapeKeyDown={disableEscapeKeyDown}
          // disableBackdropClick={disableBackdropClick}

        >
            <p className="text-myblack-100 mb-4">
            آیا از رد بیمه‌شده اطمینان دارید؟
            </p>
            <MuiTextField
              id="description"
              label="دلیل رد"
              variant="outlined"
              size="small"
              onChange={(e) => setRejectDescription(e.target.value)}
              value={rejectDescription}
              multiline
            />
            <div className="flex items-center mt-4 justify-end">
            <div className="ml-2">
              <MuiButton
                onClick={() => apiCall.reFetch()}
                variant="outlined"
                color="secondary"
                text="بله"
              />
            </div>
            <div className="">
              <MuiButton
                // onClick={() => props.onClick()}
                variant="outlined"
                color="success"
                text="خیر"
              />
            </div>
          </div>
        </MuiModal>
    </>
  );
};

export default RejectModal;
